<!--  -->
<template>
  <div>
    <van-popup class="edit-price-popup" get-container="body" v-model="isShow" @click-overlay="hidePopup" position="bottom">
      <div class="edit-price-popup-top">
        <span class="info">改价</span>
        <span class="close" @click="hidePopup">X</span>
      </div>
      <ul class="order-list">
        <li class="order-list-item"  v-for="goods in data" :key="goods.goods_id">
          <div class="order-list-item-img">
            <img :src="goods.thumb_img || $notImg" alt="">
          </div>
          <div class="order-list-item-info">
            <p class="font1">{{goods.general_name}} {{goods.norms}} {{goods.produce_unit}}</p>
            <div>
                <input v-blurScroll class="edit-price-input font1" type="text" v-model="goods.bid_price">
              <span class="ml10">(改价空间￥{{goods.low_paid}}-￥{{goods.retail_price}})</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="edit-price-popup-bottom">
          <div class="edit-price-popup-bottom-btn" @click="confirmEditPrice">
            确定
            <!-- <div class="edit-price-popup-bottom-btn-cancel" @click="hidePopup">取消</div> -->
            <!-- <div class="edit-price-popup-bottom-btn-confirm" @click="confirmEditPrice">确定</div> -->
          </div>
      </div>
    </van-popup>
  </div>

</template>

<script>
import Vue from 'vue'
import { Popup, Toast } from 'vant'
import { modifyPrice } from '~fetch/manage-center/myorder'
import { ResultCode } from '~const/ResultCode'
Vue.use(Popup)
  .use(Toast)
export default {
  components: {},

  props: {
    value: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    },
    orderNumber: {
      type: String
    }
  },

  data () {
    return {
      data: JSON.parse(JSON.stringify(this.value)),
      isShow: this.show
    }
  },

  computed: {},

  watch: {
    show () {
      this.isShow = this.show
    },
    value () {
      this.data = JSON.parse(JSON.stringify(this.value))
    }
  },

  created () {},

  methods: {
    /**
     * @description 用于没有修改价格，赋值原来的价格
     */
    hidePopup () {
      this.data = JSON.parse(JSON.stringify(this.value))
      this.$emit('update:show', false)
    },
    isCanEditPrice (data) {

    },
    /**
     * @description 确认改价
     */
    async confirmEditPrice () {
      let flag = 0
      let msg = ''
      const params = this.data.map(item => {
        if (+item.low_paid > +item.retail_price) {
          flag = 1
          msg = item.general_name
        }
        if (+item.bid_price < +item.low_paid || +item.bid_price > +item.retail_price) {
          if (!flag) {
            flag = 2
          }
        }
        return {
          order_goods_id: item.order_goods_id,
          goods_id: item.goods_id,
          bid_price: item.bid_price,
          quantity: item.quantity
        }
      })
      if (flag) {
        flag === 1 && Toast(msg + '改价空间设置不规范，请重新设置')
        flag === 2 && Toast('商品改价超出改价空间')
        return
      }
      if (JSON.stringify(this.value) === JSON.stringify(this.data)) { // 如果没改价就不请求
        this.$emit('update:show', false)
        return
      }
      let { status, info, data } = await modifyPrice({
        goods_price_arr: params,
        order_cate_number: this.orderNumber
      })
      Toast(info.msg)
      if (status === ResultCode.SUCCESS) {
        this.$emit('update:show', false)
        this.$emit('loadData', { goods_list: params, ...data })
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.edit-price-popup{
  height: 403px;
  border-radius: 15px 15px 0 0;
    &-top{
      height: 40px;
      box-sizing: border-box;
      display: flex;
      padding: 0 15px;
      justify-content: center;
      align-items: center;
      position: relative;
      border-bottom: 1px solid $border-color-base;
      .info{
        color: #333333;
        font-size: 14px;
      }
      .close{
        width: 19px;
        height: 19px;
        border-radius: 50%;
        background: #F7F6F6;
        color: #BFBFBF;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 15px;
        margin: auto;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    }
    .order-list{
      height: 306px;
      overflow-y: scroll;
      padding: 15px 15px 0;
      box-sizing: border-box;
      &-item{
        display: flex;
        justify-content: flex-start;
        margin-bottom: 15px;
        &-img{
          width: 60px;
          height: 60px;
          box-sizing: border-box;
          border:1px solid $border-color-base;
          img{
            width: 100%;
            height: 100%;
          }
        }
        &-info{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 12px;
          .edit-price-input{
              width: 66px;
              height: 24px;
              border: 1px solid #DCDCDC;
              border-radius: 4px;
              text-align: center;
              -webkit-user-select:auto; /*webkit浏览器*/
              user-select:auto;
              -o-user-select:auto;
              -ms-user-select:auto;
          }
          p{
            color: #333333;
          }
          div{
            color: #777777;
          }
        }
      }
    }
    &-bottom{
      width: 100%;
      height: 57px;
      display: flex;
      align-items:center;
      border-top: 1px solid rgba(246,246,246,1);
      box-sizing: border-box;
      &-btn{
        width: 356px;
        height: 35px;
        margin: 0 auto;
        border: 1px solid var(--APP_theme_color);
        background: var(--APP_theme_color);
        @include center();
        overflow: hidden;
        box-sizing: border-box;
        border-radius: 15px;
        color: #FFFFFF;
        font-size: 15px;
        &-cancen{
          color: var(--APP_theme_color);
          background: #f1f1f1;
        }
        &-confirm{
          background:var(--APP_theme_color);
          color: #ffffff;
        }
        div{
          display:inline-flex;
          justify-content: center;
          align-items: center;
          width: 50%;
          height: 100%;
        }
      }
    }
}
.font1{
  color: #333333
}
.font2{
  color: #777777;
}

</style>
